import Service from "./Service";
export default class Discipline {
  disciplineId?: number | null;
  code?: string | null;
  name?: string | null;
  services?: Service[] | null;

  public constructor(params: Discipline = {} as Discipline) {
    let { disciplineId = 0, code = "", name = "", services = null } = params;
    this.disciplineId = disciplineId;
    this.code = code;
    this.name = name;
    this.services = services;
  }
}
